<div class="ti-dialog__wrapper">
  <mat-dialog-content>
    <app-lexeme-edit [dialogId]="dialogId"></app-lexeme-edit>
  </mat-dialog-content>
  <mat-dialog-actions class="ti-actions">
  </mat-dialog-actions>
</div>